import { alpha } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(theme => ({
  iconCircle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 72,
    height: 72,
    borderRadius: "50%",
    backgroundColor: alpha(theme.palette.error.main, 0.1),
    color: theme.palette.error.main,
    fontSize: 28,
    marginBottom: theme.spacing(2.5),
  },
  title: { fontWeight: 700, fontSize: 20, color: theme.palette.grey[800], marginBottom: theme.spacing(1) },
  description: {
    fontSize: 14,
    color: theme.palette.grey[600],
    lineHeight: 1.6,
    maxWidth: 380,
    marginBottom: theme.spacing(2.75),
  },
  tip: {
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[500_24]}`,
    borderRadius: theme.shape.borderRadius,
    fontSize: 13,
    color: theme.palette.grey[600],
    maxWidth: 400,
  },
}));
